<template>
    <div
        class="basic-menu-list-item py-[8px] px-[15px] fade flex items-center font-medium"
        :data-testid="`${name}-value-select`"
        :class="itemClasses"
    >
        <slot name="wrapper">
            <BasicIcon
                v-if="icon"
                :class="iconClasses"
                class="mr-2.5"
                :name="icon"
                :size="iconSize"
            />
            <div class="basic-menu-list-item-text text-sm">
                <slot>
                    {{ text }}
                </slot>
            </div>
        </slot>
    </div>
</template>

<script lang="ts" setup>
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';
import { type Size } from '@atoms/BasicIcon/sizes';

export type BasicMenuListItemProps = {
    name: string;
    text?: string;
    icon?: string;
    iconSize?: Size;
    hasBorder?: boolean;
    iconClasses?: string;
    hoverable?: boolean;
    optionalData?: Record<string, unknown>;
};

const props = withDefaults(defineProps<BasicMenuListItemProps>(), {
    text: '',
    icon: '',
    iconClasses: 'fill-background-1',
    hoverable: true,
    hasBorder: false,
    iconSize: '14',
    optionalData: () => ({}),
});

const itemClasses = computed(() => {
    return {
        'cursor-pointer hover:bg-secondary-hover': props.hoverable,
        'border-input-dark border-t-[1px]': props.hasBorder,
    };
});
</script>
